import { useState, useEffect, useRef } from 'react';
import style from './secretPage.module.scss';
import Snowfall from '../components/SnowFall';

export default function SecretPage() {

    const [listOfmemes, setListofMemes] = useState([
        {id: 1, image: '/gifs/cat-cat-stare.gif', positionImg: 'MemesPosition0'},
        {id: 2, image: '/gifs/chipi-chipi-chapa-chapa.gif', positionImg: 'MemesPosition1'},
        {id: 3, image: '/gifs/harrypotter.gif', positionImg: 'MemesPosition3'},
        {id: 4, image: '/gifs/harry-potter-james-potter.gif', positionImg: 'MemesPosition4'},
        {id: 5, image: '/gifs/giphy.gif', positionImg: 'MemesPosition5'},
        {id: 6, image: '/gifs/reaction-gif-from-star-wars-of-finn-asking-are-we-actually-doing-this.gif', positionImg: 'MemesPosition6'}
    ]);

    const [showVideo, setShowVideo] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    
    const text = "I love and cherish you, you are the most special person in my life! You are the most beautiful, amazing, wonderful girlfriend in the world and I am lucky to have you. I hope life will get a bit easier soon, <3."


   
    return(
        <>
        <Snowfall/>
        <div className={style.SecretContainer}>
            <div class={style.typewriter}>
                <h1>I Love You!</h1>
            </div>
            {
                listOfmemes.map((item) => (
                    <div
                    onClick={() => item.id === 2  && setShowMessage(((prev) => !prev))}
                    data-meme-container="true" 
                    key={item.id} id="SecretContainerMemes" 
                    className={`${style.SecretContainerMemes} ${style[item.positionImg]}`
                    }>
                        
                        <img className={style.ImageSize} src={item.image} draggable={false} ></img>
                    </div>
                ))
            }

            {showMessage && (
                <div className={`${style.dropdown}`}>
                    <p>{text}</p>
                </div>
            )}

            <div className={style.YesButton} onClick={() => setShowVideo((prev) => !prev)}>
                <p className={style.YesText}>:P</p>
            </div>

            {showVideo && (
                <div className={style.videoresponsive}>
                    <iframe
                        width="853"
                        height="480"
                        src={`https://www.youtube.com/embed/33CE_4pDLkc?autoplay=1`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Embedded youtube"
                    />

                </div>
            )}
        </div>
        </>
    )
}